import { useState } from 'react'
import clsx from 'clsx'
import { Editor } from 'primereact/editor'
import Quill from 'quill'
import { FormikError } from '../formik_error/FormikError'
import TextAreaFieldStyles from './TextAreaField.module.scss'

// Define custom font sizes

const SizeStyle = Quill.import('attributors/style/size')
//@ts-ignore
SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px']
//@ts-ignore
Quill.register(SizeStyle, true)

export const TextAreaFieldFormatted = ({
  customClass = undefined,
  formik = undefined,
  field = 'customText',
  placeholder = undefined,
  label = undefined,
  isRequired = undefined,
  noLabel = false,
  customStyling = undefined,
  maxChars = undefined,
}) => {
  const [charCount, setCharCount] = useState(0)

  const handleChange = (e) => {
    if (maxChars && e.textValue.trim().length < maxChars) {
      let textEntered = e.htmlValue
      textEntered = textEntered.replaceAll('<p>', "<p style='margin:0; padding:0;'>")
      formik.setFieldValue(field, textEntered)
      setCharCount(e.textValue.trim().length)
    }
  }

  const renderHeader = () => {
    return (
      <>
        <span className="ql-formats">
          <select className="ql-size" defaultValue="14px">
            <option value="12px">12px</option>
            <option value="14px">14px</option>
            <option value="16px">16px</option>
            <option value="18px">18px</option>
            <option value="20px">20px</option>
            {/* <option value="22px">22px</option> */}
            <option value="24px">24px</option>
            {/* <option value="26px">26px</option> */}
            <option value="28px">28px</option>
            {/* <option value="30px">30px</option> */}
            <option value="32px">32px</option>
          </select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-underline" aria-label="Underline"></button>
          <button className="ql-italic" aria-label="Italic"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-link" aria-label="Hyperlink"></button>
        </span>
      </>
    )
  }
  const header = renderHeader()

  return (
    <div className={TextAreaFieldStyles['textarea__container']}>
      {!noLabel && (
        <label className={isRequired ? clsx(TextAreaFieldStyles['label'], TextAreaFieldStyles['required']) : TextAreaFieldStyles['label']}>
          {label}
        </label>
      )}
      <Editor value={formik.values[field]} onTextChange={handleChange} style={{ height: '150px' }} headerTemplate={header} />

      {maxChars && (
        <div className={clsx(TextAreaFieldStyles['max-chars'], charCount >= maxChars && [TextAreaFieldStyles['max-chars__limit-reached']])}>
          {charCount}/{maxChars}
        </div>
      )}

      {formik && formik.touched[field] && formik.errors[field] && (
        <FormikError formik={formik} fieldName={field} errorLabel={formik.errors[field]} />
      )}
    </div>
  )
}
